export default __webpack_public_path__ + "static/media/Events-Long.1215e383.jpg";